module.exports = __webpack_public_path__ + "media/images/contactese/ccentral-7831708e03274a20fed721504e1d3112.svg";